import { render, staticRenderFns } from "./Quarries.vue?vue&type=template&id=86f93122&scoped=true&"
import script from "./Quarries.vue?vue&type=script&lang=js&"
export * from "./Quarries.vue?vue&type=script&lang=js&"
import style0 from "./Quarries.vue?vue&type=style&index=0&id=86f93122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f93122",
  null
  
)

export default component.exports